import {
  POST_TINH_TRANG_NO,
  POST_TINH_TRANG_NO_SUCCESS,
  POST_TINH_TRANG_NO_FAILURE,
} from "./actionTypes";

export const postDoiTinhTrangNo = (dataPost) => ({
  type: POST_TINH_TRANG_NO,
  dataPost,
});

export const postDoiTinhTrangNoSuccess = (data) => ({
  type: POST_TINH_TRANG_NO_SUCCESS,
  payload: data,
});

export const postDoiTinhTrangNoFailure = () => ({
  type: POST_TINH_TRANG_NO_FAILURE,
});
